import { gql } from 'src/__generated__'

export default gql(`
  mutation verifyAccountRequest($data: VerifyAccountRequestInput!) {
    verifyAccountRequest(data: $data)
  }
`)
